import { render, staticRenderFns } from "./trainingClass.vue?vue&type=template&id=d7b1bbf6&scoped=true"
import script from "./trainingClass.vue?vue&type=script&lang=js"
export * from "./trainingClass.vue?vue&type=script&lang=js"
import style0 from "./trainingClass.vue?vue&type=style&index=0&id=d7b1bbf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b1bbf6",
  null
  
)

export default component.exports